import type { CSSProperties, ReactNode } from "react";

export function PageMedia({
  src,
  alt,
  className = "",
  style
}: {
  src: string;
  alt: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={`page-media ${className}`} aria-hidden={alt === ""}>
      <img src={src} alt={alt} width={1920} height={1080} fetchPriority="high" style={style} />
      <span className="page-media__veil" aria-hidden="true" />
    </div>
  );
}

export function PageIndex({ number, label }: { number: string; label: string }) {
  return (
    <div className="page-index" aria-hidden="true">
      <strong>{number}</strong>
      <span>{label}</span>
    </div>
  );
}

export function PageCopy({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`page-copy ${className}`}>{children}</div>;
}
